export class ChangeLogUtilities {
    // Syncs the open state of two parallel <details> elements if able.
    syncDetailsOpenState(self: HTMLDetailsElement, isFromOnClickEvent?: boolean) {
        // We can't easily generate IDs for the <details> elements, so instead we'll try to find matching elements
        // using the <summary> text and the index of the <details> element within its parent.
        const summaryText = self.querySelector('summary')?.innerText;

        if (!summaryText) {
            return;
        }

        const selfGrandParent = self.parentElement?.parentElement;
        if (!selfGrandParent) {
            return;
        }

        const selfIndex = [...selfGrandParent.children].indexOf(self.parentElement);

        // Find td ancestor
        let parent: HTMLElement | null = self;
        while (parent && parent.tagName !== 'TD') {
            parent = parent.parentElement;
        }

        if (!parent?.parentElement) {
            return;
        }

        // Find the parallel TD. The arrow icon is also in it's own TD, but that has a class, so 
        // explicitly ignore any TDs with classes.
        const tdParent = parent.parentElement;
        let otherTd: HTMLTableCellElement | null = null;
        for (let i = 0; i < tdParent.children.length; i++) {
            const child = tdParent.children[i];
            if (child !== parent && child.tagName === 'TD' && child.className === '') {
                otherTd = child as HTMLTableCellElement;
                break;
            }
        }

        if (otherTd === null) {
            return;
        }

        // Now, in the other TD, find all <summary> elements with the same text. Also store their index.
        const otherSummaries = otherTd.querySelectorAll('summary');
        const matchedDetails: { e: HTMLDetailsElement, i: number}[] = [];
        let idx = -1;
        for (let otherSummary of otherSummaries) {
            ++idx;
            if (otherSummary.innerText === summaryText) {
                matchedDetails.push({ e: otherSummary.parentElement as HTMLDetailsElement, i: idx });
            }
        }

        if (matchedDetails.length == 0) {
            return;
        }

        // Find the entry in matchedDetails where their index 'i' is closest to selfIndex.
        let matchedOther: HTMLDetailsElement | null = null;
        let matchedDist = 9999;
        for (const m of matchedDetails) {
            const dist = Math.abs(m.i - selfIndex);
            if (dist < matchedDist) {
                matchedOther = m.e;
                matchedDist = dist;
            }
        }

        if (matchedOther) {
            matchedOther.open = isFromOnClickEvent 
                                ? !self.open // This method is invoked from a click event, so self isn't open yet, but will be immediately after this function ends.
                                : self.open;
        }
    }
}
